import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import MainLayout from "../../layouts/main/main_layout";
import JobsLayout from "../../layouts/jobs/jobs_layout";
import JobListing from "./job_listing/job_listing";
import JobApplication from "./job_application/job_application";
import AccessDenied from "../../components/access_denied/access_denied";
import useUser from "../../providers/user/user_provider";

export default function Jobs() {
  const { hasPermission } = useUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(
    searchParams.has("currentTab") ? +searchParams.get("currentTab")! : 0
  );
  const [page, setPage] = useState(searchParams.has("page") ? +searchParams.get("page")! : 1);

  const handleTabChange = (tab: number) => {
    setPage(1);
    setCurrentTab(tab);
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        params.set("currentTab", tab.toString());
        return params;
      },
      { replace: true }
    );
  };

  return (
    <MainLayout>
      {hasPermission("jobs", "read") ? (
        <JobsLayout currentTab={currentTab} onTabChange={handleTabChange} page={page} setPage={setPage}>
          {currentTab === 0 ? (
            <JobListing currentTab={currentTab} page={page} setPage={setPage} />
          ) : (
            <JobApplication currentTab={currentTab} page={page} setPage={setPage} />
          )}
        </JobsLayout>
      ) : (
        <Box display="flex" flex={1} width="100%" height="100vh">
          <AccessDenied />
        </Box>
      )}
    </MainLayout>
  );
}
